import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { Snackbar } from '@scramble/ui';
import { getMessage } from '@/helpers/utils';
import { cashService } from '../../services/cashService';

export const useCreateBankAccount = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      cashService
        .createBankAccount(payload)
        .then(response => {
          const { status, data } = response;
          if (status === 200) {
            queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.cash.bank_accounts],
            });
            return data;
          }

          if (status === 406 || status === 400) {
            Snackbar({
              type: 'danger',
              text: getMessage(data),
            });
          }

          throw new Error(data?.message);
        })
  });
};
